import React from 'react'
import { observer } from 'mobx-react'
import InspirationUniverseContainer from 'app/React/InspirationUniverse/InspirationUniverseContainer'
import InspirationUniverseContent from 'app/React/InspirationUniverse/InspirationUniverseContent'

function InspirationUniverse (props) {
  return (
    <InspirationUniverseContainer {...props}>
      <InspirationUniverseContent/>
    </InspirationUniverseContainer>
  )
}

export default observer(InspirationUniverse)
